import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanPreQuestionsRoot } from "./pre-questions";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	preQuestions: DayTripPlanCategoriesAndManagerStore["preQuestions"];
};

export const QuestionDayTripPlanPreQuestions = ({ preQuestions }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="事前質問" categoryStore={preQuestions}>
			<QuestionPlanPreQuestionsRoot />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDayTripPlanPreQuestions.displayName = "QuestionDayTripPlanPreQuestions";
